module.exports = __webpack_public_path__ + "static/media/29.b82d9581.jpeg";